import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../../../theme/colors";

export const SeparatorContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "56px",
  marginBottom: "16px",
  backgroundColor: colors.background.mediumBlue,
  borderRadius: "8px",
  transition: "height 0.2s ease, margin-bottom 0.2s ease, border-radius 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    height: "48px",
    marginBottom: "12px",
    borderRadius: "6px",
  },
}));

export const SeparatorText = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  color: colors.text.link,
  fontWeight: 600,
  fontFamily: "Sora",
  display: "flex",
  alignItems: "center",
  gap: "4px",
  transition: "font-size 0.2s ease, gap 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
    gap: "3px",
  },
}));
